import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-xl font-bold text-primary-400">91</span>
              <span className="text-xl font-bold text-background-50">免费</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专注于免费看片软件推荐与下载，为用户提供最新最全的免费视频软件资源，覆盖安卓、苹果、电脑全平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">软件分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快捷导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/latest-recommend" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  最新推荐
                </Link>
              </li>
              <li>
                <Link to="/category/tutorial" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  使用教程
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i>
                <span>support@91free.example.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-customer-service-2-line"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 91免费. All rights reserved. 本站仅供软件信息分享，不提供任何视频内容存储服务。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-sm" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-sm" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}